// src/RuleConflictModal.jsx
export default function RuleConflictModal({
  existing,
  newRule,
  onViewExisting,
  onReplace,
  onAddMore,
  onCancel
}) {
  return (
    <div style={{ padding: "1rem", backgroundColor: "#fff", borderRadius: "8px" }}>
      <h3>This rule matches an existing rule!</h3>

      <p>
        <strong>Existing Rule:</strong> Vendor: {existing.vendor}, Plaid: {existing.plaidCategory},
        Amount: {existing.amount || "N/A"}, → {existing.category} / {existing.subcategory}
      </p>

      <p>
        <strong>New Rule:</strong> Vendor: {newRule.vendor}, Plaid: {newRule.plaidCategory},
        Amount: {newRule.amount || "N/A"}, → {newRule.category} / {newRule.subcategory}
      </p>

      <div style={{ display: "flex", gap: "0.5rem", flexWrap: "wrap", marginTop: "1rem" }}>
        {typeof onViewExisting === "function" && (
          <button
            onClick={onViewExisting}
            style={{
              backgroundColor: "#eee",
              color: "#333",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
            View existing rule
          </button>
        )}

        {typeof onAddMore === "function" && (
          <button
            onClick={onAddMore}
            style={{
              backgroundColor: "#00B074",
              color: "white",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
            Add more parameters
          </button>
        )}

        {typeof onReplace === "function" && (
          <button
            onClick={onReplace}
            style={{
              backgroundColor: "#00B074",
              color: "white",
              border: "none",
              padding: "0.5rem 1rem",
              borderRadius: "6px",
              cursor: "pointer"
            }}
          >
            Replace existing
          </button>
        )}

        <button
          onClick={onCancel}
          style={{
            backgroundColor: "#333",
            color: "white",
            border: "none",
            padding: "0.5rem 1rem",
            borderRadius: "6px",
            cursor: "pointer"
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}